<template>
  <merchant-detail :is-edit="false"></merchant-detail>
</template>
<script>
import MerchantDetail from './MerchantDetail.vue';

export default {
  name: 'addMerchant',
  components: { MerchantDetail },
};
</script>
<style>
</style>
